/* LumetierAperture — the original Lumetier brand mark.
   An asymmetric 7-blade pinwheel-aperture with a small champagne-gold dot at
   the center. The asymmetry is deliberate — wedges of different angular sweep
   and reach give the mark a hand-cut, "caught mid-rotation" editorial feel,
   not a mechanical iris.

   Blades fill with `currentColor` (or explicit `color` prop) so consumers can
   place charcoal blades on light backgrounds, cream blades on dark, etc.
   The center dot is always champagne gold #C9A961.

   Sizing: `size` in CSS px. ViewBox stays at -50..50 so blade math holds.
*/

// Each polygon: three points — outer apex, then two inner endpoints near the
// center. Inner endpoints sit around r≈8-13 so they never touch the gold dot.
// Ordered clockwise from 12 o'clock so the eye reads them as a continuous sweep.
const BLADES = [
  // 12 o'clock — narrow tall blade pointing straight up
  "0,-45 8,-12 -3,-12",
  // 1-2 o'clock — medium-narrow wedge
  "30,-32 12,-7 3,-13",
  // 3 o'clock — wide blade reaching far right
  "44,-8 13,-2 10,8",
  // 4-5 o'clock — large blade angled down-right
  "35,28 10,5 2,13",
  // 6 o'clock — medium-large blade pointing down
  "5,45 -3,12 10,11",
  // 7-8 o'clock — large blade angled down-left
  "-32,30 -11,8 -3,13",
  // 9-10 o'clock — medium blade reaching left
  "-42,5 -12,-3 -11,8",
];

export default function LumetierAperture({
  size = 28,
  color,           // blade color — defaults to currentColor
  dotColor = "#C9A961",
  className,
  title,
  "data-testid": testid,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-50 -50 100 100"
      width={size}
      height={size}
      role={title ? "img" : "presentation"}
      aria-label={title}
      aria-hidden={title ? undefined : "true"}
      className={className}
      data-testid={testid}
    >
      <g fill={color || "currentColor"}>
        {BLADES.map((points, i) => (
          <polygon key={i} points={points} />
        ))}
      </g>
      <circle cx="0" cy="0" r="3.5" fill={dotColor} />
    </svg>
  );
}
